import { render, staticRenderFns } from "./DocumentPatternEdit.vue?vue&type=template&id=1f9d3e2e"
import script from "./DocumentPatternEdit.vue?vue&type=script&lang=js"
export * from "./DocumentPatternEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports